import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label } from "reactstrap";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { CheckPermission } from "../Permissions/CheckPermissions";
import { CircularProgress } from "@material-ui/core";
import Select from "react-select";
import ReactQuill from "react-quill";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const FAQs = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];
  const [token, setToken] = useState();
  const [faqsList, setFaqsList] = useState([]);
  const [faqsData, setFaqsData] = useState();
  const [successAlert, setSuccesAlert] = useState(false);
  const [successMessage, setSuccesMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorAlert, setErrorAlert] = useState(false);
  const [loading, setloading] = useState(true);
  const [status, setStatus] = useState(statusOptions[0].value);
  const [loader, setLoader] = useState(false);
  const [refresh,setRefresh]=useState(false)

  useEffect(() => {
    setRefresh(false)
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getFaqsData(token);
  }, [refresh]);

  const getFaqsData = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/faqs/?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setloading(false);
        let response = result[0];
        setStatus(response?.status);
        setFaqsData(response);
        const sortedArray = response?.faqs.sort((a, b) => {         
          return a.sort - b.sort;        
      })
        setFaqsList(sortedArray);
      })
      .catch((error) => console.log(" errror", error));
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {successMessage ? successMessage : "Submitted"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const handleInputChange = (index, field, value) => {
    const newData = [...faqsList];
    newData[index][field] = value;
    console.log("here is the Entered Data------->",newData)
    setFaqsList(newData);
  };
  

  const handleDeleteRow = (id) => {
    const newData = faqsList.filter((item) => item.id !== id);
    let result = newData.map((item, index) => ({ ...item, sort: index + 1 }));
    setFaqsList(result);
  };  

  const handleAddRow = () => {
    const newId = Math.floor(100 + Math.random() * 900);
    const newSort = faqsList.length + 1;
    setFaqsList([
      ...faqsList,
      { id: newId.toString(), question: "", answer: "", sort: newSort },
    ]);
  };

  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const handleSubmit = () => {
    let isValid = true;
    faqsList.forEach((item, index) => {
      if (item.question.trim() === "" || stripHtml(item.answer).trim() === "") {
        isValid = false;
        setErrorMessage(`'${item.question.trim() === "" ? "Question" : "Answer"}' is missing for position ${item.sort}`)
        setErrorAlert(true)
      }
      if (!item.sort) {
        isValid = false;
        setErrorMessage(`Please enter sort value`);
        setErrorAlert(true);
      }
    });
  
    if (!isValid) {
      return;
    }
    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    faqsList?.forEach((item, index) => {
      formdata.append(`faqs[${index}][id]`, item?.id);
      formdata.append(`faqs[${index}][question]`, item?.question);
      formdata.append(`faqs[${index}][answer]`, item?.answer);
      formdata.append(`faqs[${index}][sort]`, item?.sort);
    });
    formdata.append("publish_date", "2024-05-01 11:38:26");
    formdata.append("unpublish_date", "null");
    formdata.append("status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/faqs`, requestOptions)
      .then((response) => {
        setLoader(false);
        if (response.status == 201) {
          setSuccesAlert(true);
          setRefresh(true)
          setSuccesMessage("FAQs data is submitted sucessfully");
        }else{
          setErrorAlert(true)
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Member Spend FAQs" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={4}>
                      <Button
                        disabled={!CheckPermission("faqs", "add")}
                        className="btn btn-success waves-effect waves-light"
                        onClick={() => {
                          handleAddRow();
                        }}
                      >
                        <FaPlus size={12} /> Add Question
                      </Button>
                    </Col>
                    <Col md={8} className="d-flex justify-content-md-end"></Col>
                  </Row>
                  <Card className="mt-3">
                    <CardBody>
                      {loading ? (
                        <div role="status" style={{ textAlign: "center" }}>
                          <CircularProgress
                            size={50}
                            value={100}
                            color={"black"}
                          />
                        </div>
                      ) : (
                        <div className="table-responsive mt-3 mb-5">
                          <table
                            style={{ tableLayout: "fixed" }}
                            className="table table-bordered border-primary mb-0"
                          >
                            <thead>
                              <tr>
                                <th style={{ width: "90px" }}>Sort</th>
                                <th>Question</th>
                                <th style={{ width: "60%" }}>Answer</th>
                                <th style={{ width: "75px" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {faqsList?.map((item, index) => (
                                <tr key={item.id}>
                                  <td>
                                    <input
                                      className="form-control"
                                      type="number"
                                      min="1"
                                      value={item.sort}
                                      onChange={(e) => {
                                        handleInputChange(
                                          index,
                                          "sort",
                                          parseInt(e.target.value)
                                        );
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <textarea
                                      rows={3}
                                      className="form-control"
                                      type="text"
                                      id="name_input"
                                      placeholder="Enter question here...."
                                      onChange={(e) => {
                                        handleInputChange(
                                          index,
                                          "question",
                                          e.target.value
                                        );
                                      }}
                                      value={item.question}
                                    />
                                                                    </td>
                                  <td>
                                    <ReactQuill
                                      modules={{
                                        toolbar: [
                                          ["bold", "italic", "underline"],
                                          [{ list: "ordered" }, { list: "bullet" }],
                                          ["link", { color: [] }],
                                          ["clean"],
                                        ],
                                      }}
                                      theme="snow"
                                      value={item.answer}
                                      onChange={(value) => {
                                        handleInputChange(index, "answer", value);
                                      }}
                                      placeholder="Enter answer here..."
                                    />
                                  </td>
                                  <td>
                                    <div className="d-flex justify-content-around">
                                      {CheckPermission(
                                        "faqs",
                                        "delete"
                                      ) && (
                                        <div style={{ width: 30 }}>
                                          <Link
                                            to="#"
                                            className="px-3 text-danger"
                                          >
                                            <i
                                              className="font-size-18"
                                              onClick={() => {
                                                handleDeleteRow(item.id);
                                              }}
                                            ><FaRegTrashAlt /></i>
                                          </Link>
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={4} md={6} sm={6}>
                          <div className="mb-3">
                            <Label>Status</Label>
                            <Select
                              isSearchable={true}
                              onChange={(e) => {
                                setStatus(e.value);
                              }}
                              options={statusOptions}
                              placeholder={
                                status
                                  ? status == "Y"
                                    ? "Enable"
                                    : "Disable"
                                  : "Choose..."
                              }
                              defaultValue={status}
                              required
                            />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <div
                    style={{ textAlign: "right", marginTop: 20 }}
                    className="btn-sec"
                  >
                    <Button onClick={() => {setRefresh(true)}} color="danger" type="submit">
                      Cancel
                    </Button>
                    <button
                      style={{
                        color: "#ffffff",
                        width: "80px",
                        marginLeft: "10px",
                      }}
                      className={"btn btn-success"}
                      onClick={() => {
                        handleSubmit();
                      }}
                      color="success"
                      type="submit"
                    >
                      {loader ? (
                        <CircularProgress
                          size={15}
                          value={100}
                          color={"white"}
                        />
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FAQs;
